import { ClickOutsideDirective } from '../common/services/clickOutside.directive';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { authInterceptorProviders } from "../core/auth/auth.interceptor";
import { UnauthInterceptorService } from "../core/auth/unauth-interceptor.service";
import { SharedModule } from "../shared/shared.module";
import { HeaderComponent } from "./header/header.component";
import { BaseRoutingModule } from './base-routing.module';
import { FooterComponent } from './footer/footer.component';

@NgModule({
    declarations: [HeaderComponent, ClickOutsideDirective, FooterComponent],
    imports: [
        SharedModule,
        BaseRoutingModule
    ],
    providers: [
        authInterceptorProviders,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UnauthInterceptorService,
            multi: true
        }
    ],
    exports: [HeaderComponent, FooterComponent]
})
export class BaseModule { }